<template>
  <div class="">
    <div class="innerItem">
      <p class="innerTitle setLabel">{{locale.setting_skin}}</p>
      <div v-if="responsive === 'mobile'" class="headerArrange checkbox radio">
        <p class="label toCapitalize colorGrey">{{locale.setting_skin_arrange}}</p>
        <div class="mt5 mb5">
          <input type="radio" name="skin_menu" id="skin_menu_left" value="left" v-model="skin.menu">
          <label for="skin_menu_left"><img src="~@/assets/img/skin_menu_left.png" alt=""></label>
        </div>
        <div>
          <input type="radio" name="skin_menu" id="skin_menu_right" value="right" v-model="skin.menu">
          <label for="skin_menu_right"><img src="~@/assets/img/skin_menu_right.png" alt=""></label>
        </div>
      </div>

      <div v-if="responsive === 'tablet'" class="headerArrange checkbox radio">
        <p class="label toCapitalize colorGrey">{{locale.setting_skin_active_menu_type}}</p>
        <div class="mt5 mb5">
          <input type="radio" name="skin_tablet_active_menu" id="skin_tablet_active_menu_type_default" value="default" v-model="skin.activeMenuType">
          <label for="skin_tablet_active_menu_type_default"><img src="~@/assets/img/skin_active_menu_type_default.png" alt=""></label>
        </div>
        <div>
          <input type="radio" name="skin_tablet_active_menu" id="skin_tablet_active_menu_type_block" value="block" v-model="skin.activeMenuType">
          <label for="skin_tablet_active_menu_type_block"><img src="~@/assets/img/skin_active_menu_type_block.png" alt=""></label>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Skin',
  props: [
    'locale',
    'skin',
    'lang',
    'responsive'
  ]
}
</script>

<style lang="scss" scoped>
.headerArrange label {
  display: block;
  max-width: 240px;
  padding-left: 0;
  margin-left: 2em;
  border: 1px solid $color-lgrey;
  opacity: 0.5;
  cursor: pointer;
  &:before {
    top: 50%;
    left: -2em;
    margin-top: -10px;
  }
}
.headerArrange :checked + label {
  opacity: 1;
}
</style>
